"use client";

import CountUp from "react-countup";
import { useIsDark } from "@/context/ThemeContext";
import { m, useInView } from "framer-motion";
import { useRef } from "react";

export default function StatBar() {
  const isdark = useIsDark();

  const stats = [
    { value: 100, suffix: "%", label: "Business-Focused Delivery" },
    { value: "seperator", label: "seperator" },
    { value: 95, suffix: "%", label: "Client Satisfaction" },
    { value: "seperator", label: "seperator" },
    { value: 40, suffix: "+", label: "Solutions Delivered" },
    { value: "seperator", label: "seperator" },
    { value: 10, suffix: "+", label: "Industries & Business Domains" },
  ];

  const animation = {
    initial: { opacity: 0, scale: 0.5 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeInOut" },
  };

  return (
    <div className="py-3 mobile2:py-4 md:py-6 xl:py-15 px-5 mobile:px-10 tablet:px-15 xl:px-[140px] laptop:px-[172px] dark:bg-[#0A050E] bg-[#FFFFFF]">
      <div className="relative flex flex-wrap  justify-center items-center mobile2:justify-between gap-y-3 mobile:gap-y-4 mobile2:gap-y-6 max-w-[2000px] 4xl:mx-auto">
        {stats.map((stat, i) =>
          stat.value === "seperator" ? (
            <m.div
              key={i}
              {...animation}
              className="hidden mobile2:block border-r h-4 sm:h-6 tablet:h-8 xl:h-[75px] dark:border-[#FFFFFF] border-[#9C00BB]"
            />
          ) : (
            <StatItem key={i} stat={stat} animation={animation} />
          )
        )}

        <m.div
          {...animation}
          className="block mobile2:hidden absolute top-5 bottom-5 mobile:top-4 mobile:bottom-4 left-1/2 w-px bg-[#9C00BB] dark:bg-white"
        />
      </div>
    </div>
  );
}

/* ✅ Separate component so each item can detect scroll individually */
function StatItem({ stat, animation }) {
  const ref = useRef(null);

  const inView = useInView(ref, { once: true, margin: "0px 0px -20% 0px" });

  return (
    <div className="w-1/2 mobile2:w-auto flex items-center justify-center">
      <div className="text-center" ref={ref}>
        <m.div
          {...animation}
          className="font-neutral-face text-[16px] mobile:text-[18px] sm:text-[20px] md:text-[25px] tablet:text-[30px] xl:text-4xl dark:text-[#FFFFFF] text-[#9C00BB]"
        >
          {inView ? <CountUp end={stat.value} duration={4} delay={0.2} /> : "0"}
          {stat.suffix}
        </m.div>

        <m.div
          {...animation}
          className="font-manrope text-[8px] mobile:text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[18px] mt-1 xl:mt-9 dark:text-[#9C9C9C] text-[#5A5A6E]"
        >
          {stat.label}
        </m.div>
      </div>
    </div>
  );
}
